export default __webpack_public_path__ + "static/avatar_400x400-812969d0401d75a0a71027bb1a90a13d.jpg";